import { Grid } from "@mui/material"
import { ISettingsItem } from "../../../Settings"
import { useTranslation } from "../../../i18n"

export default function Description({ name, variables }: ISettingsItem) {
  const { t } = useTranslation()
  const { text = [t.page3.welcomeDescription] } = variables || {}

  return (
    <Grid item className={name ? `${name} description` : "description"}>
      <p>{text[0]}</p>
    </Grid>
  )
}
